import { pathOr } from 'ramda';
import { SafeApiError } from './../errors';

/**
 * Attempts to map a raw API response error into a SafeApiError. A SafeApiError is created
 * when the raw response contains a `code`, `message`, and `help` message. The `help`
 * message is assumed to be safe to show the user.
 *
 * @param {Error} error
 * @throws {Error}
 * @throws {SafeApiError}
 */
var coerceToSafeApiError = function coerceToSafeApiError(error) {
  if (!error.isAxiosError) {
    throw error;
  }
  var responseData = pathOr({}, ['response', 'data'], error);
  var help = responseData.help,
    details = responseData.details,
    message = responseData.message,
    code = responseData.code;
  if (code && help && typeof help === 'string' && message && typeof message === 'string') {
    throw new SafeApiError(help, message, details, code, error.response, error);
  }
  throw error;
};
export default coerceToSafeApiError;